import {
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { APP_API } from "../../constants/constants";
import { removeHash } from "../../utils/hash";

export const cashCollectionAppServiceApi = createApi({
  reducerPath: "cashCollectionAppServiceApi",
  baseQuery: async (args: string | FetchArgs, api, extraOptions) => {
    const rawBaseQuery = fetchBaseQuery({
      baseUrl: APP_API,
      prepareHeaders: (headers, { getState }) => {
        const token = (getState() as any).auth?.access_token;

        if (token) headers.set("Authorization", `Bearer ${token}`);

        headers.set("ngrok-skip-browser-warning", "true");
        return headers;
      },
    });

    const asObj: FetchArgs =
      typeof args === "string" ? { url: args } : { ...args };

    const productType = localStorage.getItem("product-type");
    const productId = productType ? removeHash(JSON.parse(productType)) : null;

    const dynamic = localStorage.getItem("dynamic");
    const dynamicData = dynamic ? JSON.parse(dynamic) : null;

    const defaultParams = {
      productId,
      // supplierKeyword:
      //   removeHash(dynamicData?.dynamicKeyword?.split(" ")?.join("+")) || null,
      // supplierId:
      //   removeHash(dynamicData?.dynamicId?.split(" ")?.join("+")) || null,
    };

    asObj.params = { ...defaultParams, ...(asObj.params ?? {}) };

    return rawBaseQuery(asObj, api, extraOptions);
  },

  tagTypes: [
    "GetZone",
    "GetArea",
    "GetTerritory",
    "GetRoute",
    "GetRouteSingle",
    "GetSR",
    "GetSRSingle",
    "GetTransactions",
    "GetAllCollectionPoint",
    "GetSingleCollectionPoint",
    "GetTransactionsSummary",
    "GetTransitionDetails",
    "GetCashCollectionState1",
    "GetCashCollectionState2",
    "GetCashCollectionState3",
    "GetCashCollectionState4",
    "GetBankTransactions",
    "GetCashCollection",
  ],
  keepUnusedDataFor: 0,

  endpoints: () => ({}),
});
